import { render, staticRenderFns } from "./ProfileUpdatePending.vue?vue&type=template&id=51e0b1f4"
import script from "./ProfileUpdatePending.vue?vue&type=script&lang=js"
export * from "./ProfileUpdatePending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports